// extracted by mini-css-extract-plugin
export default {"SharePanel":"SharePanel_SharePanel__Fcm1v","Icon":"SharePanel_Icon__pm8eI","Header":"SharePanel_Header__bYOIi"};